export const CONTENTS_REQUEST = "CONTENTS_REQUEST";
export const CONTENTS_SUCCESS = "CONTENTS_SUCCESS";
export const CONTENTS_FAILURE = "CONTENTS_FAILURE";
export const CONTENTSID_REQUEST = "CONTENTSID_REQUEST";
export const CONTENTSID_SUCCESS = "CONTENTSID_SUCCESS";
export const CONTENTSID_FAILURE = "CONTENTSID_FAILURE";